import { render, staticRenderFns } from "./sSelectedSubzona.vue?vue&type=template&id=40843f96"
import script from "./sSelectedSubzona.vue?vue&type=script&lang=js"
export * from "./sSelectedSubzona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports